import React from "react";
import UpdateAccountInformationForm from "../../components/Form/UpdateAccountInformation/UpdateAccountInformation";

const UpdateAccountInformation = () => {
  return (
    <div>
      <UpdateAccountInformationForm />
    </div>
  );
};

export default UpdateAccountInformation;
